import { c as _c } from "react/compiler-runtime";
import { useSyncExternalStore } from "react";
export const MD_MEDIA_QUERY = "(min-width: 768px)";
export function useMediaQuery(query) {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== query) {
    t0 = callback => {
      const mq = window.matchMedia(query);
      mq.addEventListener("change", callback);
      return () => mq.removeEventListener("change", callback);
    };
    t1 = () => window.matchMedia(query).matches;
    $[0] = query;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  return useSyncExternalStore(t0, t1, _temp);
}
function _temp() {
  return false;
}